"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var SheetImportant = function SheetImportant(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M30.8888889,7.2 C32.6,7.2 34,8.64 34,10.4 L34,32.8 C34,34.56 32.6,36 30.8888889,36 L9.11111111,36 C7.4,36 6,34.56 6,32.8 L6,10.4 C6,8.64 7.4,7.2 9.11111111,7.2 L15.6133333,7.2 C16.2666667,5.344 17.9777778,4 20,4 C22.0222222,4 23.7333333,5.344 24.3866667,7.2 L30.8888889,7.2 Z M21.5555556,31.2 L21.5555556,28 L18.4444444,28 L18.4444444,31.2 L21.5555556,31.2 Z M21.5555556,24.8 L21.5555556,15.2 L18.4444444,15.2 L18.4444444,24.8 L21.5555556,24.8 Z M20,10.4 C20.8555556,10.4 21.5555556,9.68 21.5555556,8.8 C21.5555556,7.92 20.8555556,7.2 20,7.2 C19.1444444,7.2 18.4444444,7.92 18.4444444,8.8 C18.4444444,9.68 19.1444444,10.4 20,10.4 Z"
      });
    }
  }));
};
SheetImportant.defaultProps = {
  color: null
};
var _default = exports["default"] = SheetImportant;
var name = exports.name = 'SheetImportant';
var availableProps = exports.availableProps = ['color'];